"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserGiveawaySchedulerEndpoint = void 0;
const giveaways_constants_1 = require("root/src/shared/giveaways/giveaways.constants");
const auth_1 = require("root/src/shared/constants/auth");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const recordTypes_1 = require("root/src/shared/descriptions/endpoints/recordTypes");
const rewards_api_contract_1 = require("@daredrop-com/rewards-api-contract");
exports.updateUserGiveawaySchedulerEndpoint = {
    [giveaways_constants_1.giveawayEndpointIds.UPDATE_USER_GIVEAWAY_SCHEDULER]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.betaTester,
        endpointType: lenses_1.recordEndpointType,
        recordType: recordTypes_1.giveawayScheduler,
        payloadSchema: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                },
                durationTime: {
                    type: 'integer',
                    minimum: giveaways_constants_1.MIN_DURATION_TIME,
                },
                repeatTimes: {
                    type: ['integer', 'null'],
                    minimum: giveaways_constants_1.MIN_REPEAT_TIMES,
                    maximum: giveaways_constants_1.MAX_REPEAT_TIMES,
                    errorMessage: {
                        minimum: `Repeat times must be at least ${giveaways_constants_1.MIN_REPEAT_TIMES}`,
                        maximum: `Repeat times must be at most ${giveaways_constants_1.MAX_REPEAT_TIMES}`,
                    },
                },
                status: {
                    type: 'string',
                    enum: Object.values(rewards_api_contract_1.GiveawaySchedulerConfigStatus),
                },
            },
            required: ['id'],
        },
    },
};
